import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { useRef } from "react";

import erpBg from "../../assets/section-2.jpg"; // change if needed

function Learnmore() {
  const swiperRef = useRef(null);

  return (
    <section style={{ width: "100%", overflow: "hidden" }}>
      {/* Section Heading */}
      <h2
        style={{
          textAlign: "center",
          padding: "25px 0",
          fontSize: "36px",
          fontWeight: "600",
        }}
      >
        Our Core Services
      </h2>

      <div style={{ position: "relative", width: "100%" }}>
        {/* Left Arrow */}
        <div
          onClick={() => swiperRef.current?.slidePrev()}
          style={navStyleLeft}
        >
          <BsChevronLeft color="#fff" size={20} />
        </div>

        {/* Right Arrow */}
        <div
          onClick={() => swiperRef.current?.slideNext()}
          style={navStyleRight}
        >
          <BsChevronRight color="#fff" size={20} />
        </div>

        {/* Swiper Slider */}
        <Swiper
          modules={[Autoplay]}
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          loop={true}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          style={{ width: "100%", height: "85vh" }}
        >
          {/* Slide 1 */}
          <SwiperSlide>
            <SlideContent
              title="Custom Application Development"
              description="Every business is unique, and so are its software needs..."
              bgImage={erpBg}
              isMain={true} // 👈 This becomes H1
            />
          </SwiperSlide>

          {/* Slide 2 */}
          <SwiperSlide>
            <SlideContent
              title="Enterprise Resource Planning (ERP)"
              description="Our AccessONE ERP platform empowers organizations..."
              bgImage={erpBg}
            />
          </SwiperSlide>

          {/* Slide 3 */}
          <SwiperSlide>
            <SlideContent
              title="Database Administration Services"
              description="Keep your critical data secure..."
              bgImage={erpBg}
            />
          </SwiperSlide>
        </Swiper>
      </div>
    </section>
  );
}

/* Slide Content Component */
const SlideContent = ({ title, description, bgImage, isMain }) => {
  const HeadingTag = isMain ? "h1" : "h2";

  return (
    <div
      style={{
        width: "100%",
        height: "85vh",
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "relative",
          zIndex: 2,
          textAlign: "center",
          maxWidth: "900px",
          padding: "20px",
        }}
      >
        <HeadingTag
          style={{
            fontSize: "48px",
            fontWeight: "600",
            marginBottom: "20px",
            color: "#ffffff",
          }}
        >
          {title}
        </HeadingTag>

        <p
          style={{
            fontSize: "18px",
            lineHeight: "1.7",
            color: "#ffffff",
          }}
        >
          {description}
        </p>
      </div>
    </div>
  );
};

/* Arrow Styles */
const navStyleLeft = {
  position: "absolute",
  top: "50%",
  left: "20px",
  transform: "translateY(-50%)",
  zIndex: 20,
  cursor: "pointer",
  background: "rgba(0,0,0,0.4)",
  width: "45px",
  height: "45px",
  borderRadius: "4px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const navStyleRight = {
  ...navStyleLeft,
  left: "auto",
  right: "20px",
};

export default Learnmore;
